import { all } from "redux-saga/effects";
import { monHocSaga } from "./monhHocSaga";
import { thanhPhanMonSaga } from "./thanhPhanMonSaga";
import { congThucTinhDiemSaga } from "./congThucTinhDiemSaga";
import { congThucTinhDiemSubSaga } from "./congthucTinhDiemSubSaga";
import { thanhPhanThiSaga } from "./ThanhPhanThiSaga";
import { quyCheSaga } from "./quyCheSaga";
import { diemQuyDoiSaga } from "./diemQuyDoiSaga";
import { xepLoaiHocTapSaga } from "./xepLoaiHocTapSaga";
import { xepHangTotNghiepSaga } from "./xepHangTotNghiepSaga";
import { xepLoaiChungChiSaga } from "./xepLoaiChungChiSaga";
import { loaiChungChiSaga } from "./loaiChungChiSaga";
import { tieuDeBaoCaoSaga } from "./tieuDeBaoCaoSaga";
import { lopSaga } from "./lopSaga";
import { trangThaiHocSaga } from "./trangThaiHocSaga";
import { hocKyDangKySaga } from "./hocKyDangKySaga";
import { thamSoHeThongChucNangSaga } from "./thamSoHeThongChucNangSaga";
import { thamSoHeThongSaga } from "./thamSoHeThongSaga";
import { diemKyHieuSaga } from "./diemKyHieuSaga";
import { loaiChungChiChungNhanSaga } from "./loaiChungChiChungNhanSaga";
import { loaiBangTotNghiepSaga } from "./loaiBangTotNghiepSaga";
import { quocTichSaga } from "./quocTichSaga";
import { boMonSaga } from "./boMonSaga";
import { khoiNganhSaga } from "./khoiNganhSaga";
import { hinhThucThiSaga } from "./hinhThucThiSaga";
import { heSaga } from "./heSaga";

export default function* categorySagaWrapper() {
  yield all([
    monHocSaga(),
    thanhPhanMonSaga(),
    thanhPhanThiSaga(),
    congThucTinhDiemSaga(),
    congThucTinhDiemSubSaga(),
    quyCheSaga(),
    diemQuyDoiSaga(),
    xepLoaiHocTapSaga(),
    xepHangTotNghiepSaga(),
    xepLoaiChungChiSaga(),
    loaiChungChiSaga(),
    tieuDeBaoCaoSaga(),
    lopSaga(),
    trangThaiHocSaga(),
    hocKyDangKySaga(),
    thamSoHeThongChucNangSaga(),
    thamSoHeThongSaga(),
    diemKyHieuSaga(),
    loaiChungChiChungNhanSaga(),
    loaiBangTotNghiepSaga(),
    quocTichSaga(),
    boMonSaga(),
    khoiNganhSaga(),
    hinhThucThiSaga(),
    heSaga(),
  ]);
}
